import { useEffect } from 'react'
import classNames from 'classnames'
import { withRouter } from 'i18n/utils'

import { CardSection } from 'shared/components/CardSection'
import ErrorMessage from 'shared/components/ErrorMessage'
import Button from 'shared/components/Button'
import CircleLoader from '@components/CircleLoader'

import withRates from 'booking/components/withRates'
import { setLastBookingDetails } from '@booking/actions'
import { waitingListKeySelector } from '@booking/selectors'

import { selectedEventSelector, eventsListSelector, eventsSearchPendingSelector } from 'search/selectors'
import { fetchEvents, setEvent, removeEvent } from 'search/actions'

import DateSelection from './DateSelection'
import EventProduct from './EventProduct'

import styles from 'booking/components/BookingView/components/styles.module.scss'
import eventStyles from '../styles.module.scss'

const DateProductSelection = ({
    grsId,
    setDateRange,
    onNext,
    setProduct,
    fetchEvents,
    setEvent,
    eventsList,
    eventsSearchPending,
    bookingData,
    selectedEvent,
    setLastBookingDetails,
    currentItemIndex,
    waitingListKey,
    removeEvent,
}) => {
    useEffect(() => {
        removeEvent()
        fetchEvents({ locationId: grsId })
    }, [])

    useEffect(() => {
        if (selectedEvent) {
            setDateRange({
                startDate: selectedEvent.fromDate,
                endDate: selectedEvent.toDate,
                displayValue: `${selectedEvent.fromDate.format('DD-MM-YYYY')} — ${selectedEvent.toDate.format(
                    'DD-MM-YYYY'
                )}`,
            })
        }
    }, [selectedEvent])

    const onNextStep = () => {
        setProduct({ ...selectedEvent, displayValue: selectedEvent.eventName })
        onNext()
    }

    const onDateInputChange = (startDate, endDate) => {
        if (!startDate && !endDate) {
            setDateRange(null)
            removeEvent()
            fetchEvents({ locationId: grsId })
        } else {
            setDateRange({
                startDate: startDate,
                endDate: endDate,
                displayValue: `${startDate.format('DD-MM-YYYY')} — ${endDate.format('DD-MM-YYYY')}`,
            })

            fetchEvents({
                locationId: grsId,
                startDate: startDate,
                endDate: endDate,
            })
        }
    }

    useEffect(() => {
        setLastBookingDetails({
            id: currentItemIndex,
            grsId,
            selectedEvent,
            waitingListKey,
            rate: selectedEvent,
        })
    }, [selectedEvent])

    return (
        <>
            <CardSection className={styles.contentSection} loading={false}>
                <h3 className={eventStyles.headlineMobileVersion}>
                    <T>booking.event.parking</T>
                </h3>
                <DateSelection onDateInputChange={onDateInputChange} />
                {!eventsSearchPending && eventsList.length === 0 && (
                    <ErrorMessage messages={[<T>booking.event.no.results</T>]} />
                )}
                {eventsSearchPending ? (
                    <div className="row justify-content-center m-6">
                        <CircleLoader />
                    </div>
                ) : (
                    eventsList.length > 0 &&
                    eventsList.map((event, i) => (
                        <EventProduct
                            key={i}
                            event={event}
                            date={bookingData.date}
                            setActiveProduct={setEvent}
                            selectedEvent={selectedEvent}
                        />
                    ))
                )}
                <div className={classNames('row', styles.nextButtonContainer)}>
                    <Button
                        btnStyle="primary"
                        onClick={onNextStep}
                        disabled={!selectedEvent || eventsSearchPending}
                        className={styles.nextButton}>
                        <T>subscription.purchase.label.next</T>
                    </Button>
                </div>
            </CardSection>
        </>
    )
}

export default compose(
    withRouter,
    connect(
        createStructuredSelector({
            selectedEvent: selectedEventSelector,
            eventsList: eventsListSelector,
            eventsSearchPending: eventsSearchPendingSelector,
            waitingListKey: waitingListKeySelector,
        }),
        {
            removeEvent,
            setEvent,
            fetchEvents,
            setLastBookingDetails,
        }
    )
)(withRates(DateProductSelection))
